import FormTools from '../utils/formTools';

window.FormTools = new FormTools();

function addFormButtonFromInputSubmit() {
	const $form = $('form');
	const $submitBtn = $form.find('input[type="submit"]');
	if ($submitBtn.length > 0) {
		//console.log('BTN:', $submitBtn);
		$submitBtn.each((index, element) => {
			const $element = $(element);
			const buttonText = $element.val() || 'Submit';
			const $button = $('<button class="btn btn-arrow" type="submit"></button>').text(buttonText);
			$element.replaceWith($button);
		});
	}
}

$(() => {
	window.FormTools.init();
	addFormButtonFromInputSubmit();
});